/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React from 'react';
import PropTypes from 'prop-types';
import { SelectInput } from 'react-admin';

const AssetGenerationTypeSelector = (props) => {
  return (
    <SelectInput
      {...props}
      label="Asset Generation Type"
      choices={[
        { id: 'procedural', name: 'Procedural' },
        { id: 'captured', name: 'Captured' },
        { id: 'handpainted', name: 'Handpainted' },
      ]}
    />
  );
};

AssetGenerationTypeSelector.propTypes = {
  record: PropTypes.object.isRequired,
  source: PropTypes.string.isRequired,
};

AssetGenerationTypeSelector.defaultProps = {
  record: {},
};

export default AssetGenerationTypeSelector;
